import React from 'react';

export const LocationContext = React.createContext({} as Location);
export const LocationContextProvider = LocationContext.Provider;
export const LocationContextConsumer = LocationContext.Consumer;
